export const HYDROZONE_TYPE_UPLAND = 1;
export const HYDROZONE_TYPE_TRANSITION = 2;
export const HYDROZONE_TYPE_OVERBANK = 3;
export const HYDROZONE_TYPE_BANK = 4;
export const HYDROZONE_TYPE_TOE = 5;

export const PLOT_TYPE_1 = 1;
export const PLOT_TYPE_2 = 2;
